import { INonBilledSession } from 'src/store/reducers/nonBilledSessionsReport-reducer';
import { changeToZeroMoment } from '../timeHelpers';
import CaseEnum from 'src/enumerables/case-enum';
import OrderEnum from 'src/enumerables/order-enum';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';

export const enumLabel = (options: SelectObject[], value: number | string | null | undefined): string =>
    options.find((it) => String(it.value) === String(value))?.label ?? '';

export const studentName = (it: INonBilledSession): string =>
    `${it.student?.firstName ?? ''} ${it.student?.lastName ?? ''}`.trim();

export const groupNonBilledSessionsReportToCsv = (data: INonBilledSession[]) => {
    const caseTypes = getValFromEnum(CaseEnum ? CaseEnum.getEnum('caseType') : {});
    const orderTypes = getValFromEnum(OrderEnum ? OrderEnum.getEnum('OrderType') : {});
    const groupData: any = [
        [
            'Session ID',
            'Date',
            'Start',
            'End',
            'Provider ID',
            'Provider',
            'Student ID',
            'Student',
            'Service Type ID',
            'Service Type',
            'Case Number',
            'Case Type',
            'Order Type',
        ],
    ];

    data.forEach((it) => {
        groupData.push([
            it.id,
            it.seanceDate ? changeToZeroMoment(it.seanceDate, 'MM/DD/YYYY') : '',
            it.startTime ? changeToZeroMoment(it.startTime, 'hh:mm A') : '',
            it.endTime ? changeToZeroMoment(it.endTime, 'hh:mm A') : '',
            it.provider?.id ?? '',
            it.provider?.fullName ?? '',
            it.student?.id ?? '',
            studentName(it),
            it.serviceType?.id ?? '',
            it.serviceType?.title ?? '',
            it.occasion?.caseNumber ?? '',
            enumLabel(caseTypes, it.occasion?.caseType),
            enumLabel(orderTypes, it.occasion?.orderType),
        ]);
    });

    return groupData;
};
